module.exports = __webpack_public_path__ + "static/media/ic_close.3bf475b2.svg";